module.exports = __webpack_public_path__ + "img/mflower.c8ce4b9c.png";